import _ from 'lodash/object';

const initialState = {
    path: [],
    menu: {
        disableOptions: [],
        filtersOnMenu: [],
        collapseOptions: true
    },
    filters: {
        collapseAll: false,
        collapseAllLineChart: true,
        collapseAllRadioChart: true,
        hideFiltersOnMenu: false,
        dataTotalLimit: 45000,
        ddEnabled: true,
      
    },
    ui: '',
    collapseNote: true
}

const menuReducer = (state = {}, action) => {
    switch (action.type) {
        case 'COLLAPSE':
            return { ...state, collapseOptions: action.payload }
        default: return state;
    }
}

const filterReducer = (state = {}, action) => {
    switch (action.type) {
        case 'SET_COLLAPSE_ALL':
            return { ...state, collapseAll: action.payload };
        case 'SET_DD_ENABLED':
            return { ...state, ddEnabled: action.payload };
        case 'SET_COLLAPSE_ALL_LINE_CHART':
            return { ...state, collapseAllLineChart: action.payload };
        case 'SET_COLLAPSE_ALL_RADIO_CHART':
            return { ...state, collapseAllRadioChart: action.payload };
        default: state;
    }
}


export default (state = initialState, action) => {
    switch (action.type) {
        case 'SET_CONFIG':
            const nState = { ...state, path: [] };
            return _.merge({ ...nState }, action.payload);
        case 'IS_LOADED':
            return { ...state, isLoading: action.payload }
        case 'COLLAPSE':
            return { ...state, menu: menuReducer(state.menu, action) };
        case 'SET_COLLAPSE_NOTE':
                return { ...state, collapseNote: action.payload};
        case 'SET_COLLAPSE_ALL':
        case 'SET_DD_ENABLED':
            return { ...state, filters: filterReducer(state.filters, action) }
        default: return state;
    }
}
